import { z } from 'zod';
import { timestampSchema } from './common';

/** Response for `GET /api/health` — liveness plus a binding sanity check. */
export const healthResponseSchema = z.object({
  status: z.literal('ok'),
  timestamp: timestampSchema,
  bindings: z.object({
    db: z.boolean(),
  }),
});
export type HealthResponse = z.infer<typeof healthResponseSchema>;
